module.exports = __webpack_public_path__ + "img/AdobeStock_213804967.9c8e39be.jpeg";